// import React from 'react'
// import { Provider, atom, useAtom } from 'jotai';

// const textAtom = atom("hello");

// export function setAtom (value) {
//     const [teste, setTeste] = useAtom(textAtom);
//     setTeste(value)
// }

// export function voltarAtom () {
//     return atom((get) => get(textAtom))
// }

import create from "zustand"

export const useStore = create((set) => ({
    chosenToggleState: 'sectors',  
    OnChangeToggleState: (el) => set((state) => ({ chosenToggleState: el })),
    chosenSectorState: { name: '' },
    OnChangeSectorState: (el) => set((state) => ({ chosenSectorState: el })),
    chosenLineState: { name: '' },
    OnChangeLineState: (el) => set((state) => ({ chosenLineState: el })),
    chosenPilarState: { name: '' },
    OnChangePilarState: (el) => set((state) => ({ chosenPilarState: el })),
    chosenMachineState: { name: '' },
    OnChangeMachineState: (el) => set((state) => ({ chosenMachineState: el })),
  // inc: () => set((state) => ({ count: state.count + 1 })),
}))

// addPokemons: (pokemon) =>
// set((state) => ({
//  pokemons: [
//  { name: pokemon.name, id: Math.random() * 100 },
//   ...state.pokemons,
//  ]})),

// export function Counter() {
//   const { count, inc } = useStore()
//  inc(true)
// }
